/**
 * @file checkboxempty の状態管理
 */
'use strict'

/**
 * @classname CheckboxEmpty
 * @classdesc checkboxempty の状態管理
 */
export default class CheckboxEmpty {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.validate[data-validate="checkboxempty"][name]')
	 */
	constructor($e) {
		console.log('CheckboxEmpty.constructor')
		this._$e = $e
		this._$checkboxes = this._$e.closest('.form-group').find('.validate[data-validate="checkboxempty"][name]')
		this._$errorTip = this._$e.closest('.form-group').find('.error-tip')
		this._$checkAllCheckbox = this._$e.closest('.form-group').find('.check-all-checkbox')
		this._$e.on('click', () => this.onClick())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof CheckboxEmpty
	 * @return {undefined}
	 */
	onClick() {
		console.log('CheckboxEmpty.onClick')
		if (this._$e.prop('checked')) {
			this._$checkAllCheckbox.removeClass('is-invalid')
			let allChecked = true
			this._$checkboxes.each((_, element) => {
				$(element).removeClass('is-invalid')
				if (!$(element).prop('checked')) allChecked = false
			})
			if (allChecked) this._$checkAllCheckbox.prop('checked', true)
			this._$errorTip.removeClass('show')
		} else {
			this._$checkAllCheckbox.prop('checked', false)
		}
	}
}
